import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { useSelector } from "react-redux";
import {
  getAllCountries,
  getCitiesByCountry,
  getDialCodeByCountry,
} from "../../data/countriesData";

const AddNewUsers = ({
  show,
  setShow,
  setFormData,
  formData,
  passwordError,
  onSubmit,
  action,
}) => {
  const [notification, setNotification] = useState({
    show: false,
    title: "",
    body: "",
    button: "",
  });
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [admins, setAdmins] = useState([]);
  const [accounts, setAccounts] = useState({ iaai: { buyer: [] }, copart: [] });
  const [destinationPorts, setDestinationPorts] = useState([]);
  const admin = useSelector((state) => state.user);

  useEffect(() => {
    // Load countries from static data
    const staticCountries = getAllCountries();
    setCountries([...staticCountries]);

    if (admin.role === "sadmin") {
      axios("/api/admins?limit=100&page=1")
        .then((response) => {
          const data = response.data.data;
          setAdmins([...data]);
        })
        .catch((err) => {
          setNotification({
            show: true,
            title: "Error",
            body: "Admins not loaded",
            button: "Close",
          });
        });

      setFormData((prev) => ({ ...prev, adminName: admin.username }));
    }

    axios("/api/accounts?limit=100&page=1")
      .then((response) => {
        const data = response.data.data;
        const copart = data.filter((a) => a.auction === "copart");
        let iaai = data.filter((a) => a.auction === "iaai");
        iaai = iaai.map((i) => ({ label: i.buyer, value: i.buyer }));
        setAccounts({ copart: [...copart], iaai: iaai });
      })
      .catch((err) => {
        setNotification({
          show: true,
          title: "Error",
          body: "Admins not loaded",
          button: "Close",
        });
      });
  }, []);

  useEffect(() => {
    axios.get('/api/destination-ports')
      .then((response) => {
        setDestinationPorts(response.data.data);
      })
      .catch((err) => {
        setNotification({
          show: true,
          title: "Error",
          body: "Destination ports not loaded",
          button: "Close",
        });
      });
  }, []);

  const getSelectedDestinationPort = (id) => {
    const port = destinationPorts.find((port) => port.id === id)
    if(port) {
      return { label: port.name, value: port.id }
    }
    return null;
  }

  return (
    <>
      <Modal
        show={show}
        onHide={setShow}
        size={"lg"}
        dialogClassName="aside-modal"
      >
        <Modal.Header>
          <h4>{action == "edit" ? "Edit user" : "Add new user"}</h4>
        </Modal.Header>
        <Modal.Body style={{ overflowY: "auto" }}>
          <form
            className={"add-new-users-form"}
            onSubmit={(e) => {
              e.preventDefault();
              onSubmit();
            }}
          >
            <div className={"row"}>
              <div className={"col-md-6"}>
                <div className={"form-group"}>
                  <label>Name</label>
                  <input
                    required
                    type={"text"}
                    value={formData.name}
                    className={"form-control"}
                    placeholder={"Enter name"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className={"form-group"}>
                  <label>Surname</label>
                  <input
                    required
                    type={"text"}
                    value={formData.surname}
                    className={"form-control"}
                    placeholder={"Enter surname"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        surname: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className={"form-group"}>
                  <label>Country</label>
                  <select
                    required
                    value={formData.country}
                    className={"form-control"}
                    onChange={(e) => {
                      const selectedCountry = e.target.value;
                      setFormData((prev) => ({
                        ...prev,
                        country: selectedCountry,
                      }));

                      // Get dial code from static data
                      const dialCode = getDialCodeByCountry(selectedCountry);
                      if (dialCode) {
                        setFormData((prev) => ({
                          ...prev,
                          phone: `${dialCode} `,
                        }));
                      }

                      // Get cities from static data
                      const citiesList = getCitiesByCountry(selectedCountry);
                      setCities([...citiesList]);
                    }}
                  >
                    <option>Select country</option>
                    {countries.map((c) => (
                      <option value={c.name} key={c.iso2}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={"form-group"}>
                  <label>City</label>
                  <select
                    required
                    value={formData.city}
                    className={"form-control"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }));
                    }}
                  >
                    <option>Select City</option>
                    {cities.map((c) => (
                      <option value={c} key={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={"form-group"}>
                  <label>Username</label>
                  <input
                    type={"text"}
                    required
                    value={formData.username}
                    className={"form-control"}
                    placeholder={"Enter username"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        username: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className={"form-group"}>
                  <label>Password</label>
                  <input
                    type={"password"}
                    required={action !== "edit"}
                    value={formData.password}
                    className={"form-control"}
                    placeholder={"Enter password"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        password: e.target.value,
                      }));
                    }}
                  />
                  {passwordError && (
                    <span className={"authorization-error"}>
                      Please insert more then 6 symbol
                    </span>
                  )}
                </div>
                <div className={"form-group"}>
                  <label>Email</label>
                  <input
                    type={"email"}
                    required
                    value={formData.email}
                    className={"form-control"}
                    placeholder={"Enter email"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className={"form-group"}>
                  <label>Select auth flow</label>
                  <select
                    required
                    value={formData.authMode}
                    className={"form-control"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        authMode: Number(e.target.value),
                      }));
                    }}
                  >
                    <option value={1}>Old flow</option>
                    <option value={2}>New flow</option>
                  </select>
                </div>
                <div className={"form-group"}>
                  <label>Main destination port</label>
                  <Select
                    className={"form-control no-padding"}
                    options={destinationPorts.map((port) => ({ label: port.name, value: port.id }))}
                    value={getSelectedDestinationPort(formData.mainDestinationPort)}
                    onChange={(e) => {
                      console.log(e);
                      setFormData((prev) => ({ ...prev, mainDestinationPort: e.value }));
                    }}
                  />
                </div>
              </div>
              <div className={"col-md-6"}>
                <div className={"form-group"}>
                  <label>Phone</label>
                  <input
                    type={"text"}
                    required
                    value={`${formData.phone}`}
                    className={"form-control"}
                    placeholder={"Enter phone"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        phone: `${e.target.value}`,
                      }));
                    }}
                  />
                </div>
                {admin.role === "sadmin" && (
                  <div className={"form-group"}>
                    <label>Admin</label>
                    <select
                      value={formData.adminName}
                      className={"form-control"}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          adminName: e.target.value,
                        }));
                      }}
                    >
                      <option>Select Admin</option>
                      {admins.map((c) => (
                        <option value={c.username} key={c.id}>
                          {c.username}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className={"form-group"}>
                  <label>Copart account</label>
                  <select
                    value={formData.copartAccount}
                    className={"form-control"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        copartAccount: e.target.value,
                      }));
                    }}
                  >
                    <option>Select Account</option>
                    {accounts.copart.map((c) => (
                      <option value={c.buyer} key={c.buyer}>
                        {c.buyer}
                      </option>
                    ))}
                  </select>
                </div>
                <div className={"form-group"}>
                  <label>IAAI account</label>
                  <Select
                    isMulti
                    className={"form-control no-padding"}
                    options={accounts.iaai}
                    value={formData.iaaiAccount}
                    onChange={(e) => {
                      setFormData((prev) => ({ ...prev, iaaiAccount: [...e] }));
                    }}
                  />
                </div>
                {formData.hasLimit && (
                  <div className={"form-group"}>
                    <label>Bid limit</label>
                    <input
                      type={"text"}
                      required
                      value={`${formData.bidLimit}`}
                      className={"form-control"}
                      placeholder={"Enter bid limit"}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          bidLimit: e.target.value,
                        }));
                      }}
                    />
                  </div>
                )}
                {formData.lotHistory && (
                  <div className={"form-group"}>
                    <label>Lot history limit</label>
                    <input
                      type={"number"}
                      required
                      value={`${formData.lotHistoryCount}`}
                      className={"form-control"}
                      placeholder={"Enter lot history limit"}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          lotHistoryCount: e.target.value,
                        }));
                      }}
                    />
                  </div>
                )}
                <div className={"form-group"}>
                  <label>Controls</label>
                  <div
                    className={"form-checkboxes"}
                    style={{ justifyContent: "space-between" }}
                  >
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"copart-status"}
                        type={"checkbox"}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            copartStatus: e.target.checked,
                          }));
                        }}
                        className={"form-check-input"}
                        defaultChecked={[formData].some(
                          (i) => i.copartStatus === true
                        )}
                      />
                      <label
                        htmlFor={"copart-status"}
                        className={"form-check-label"}
                      >
                        Copart
                      </label>
                    </div>
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"iaai-status"}
                        defaultChecked={[formData].some(
                          (i) => i.iaaiStatus === true
                        )}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            iaaiStatus: e.target.checked,
                          }));
                        }}
                        type={"checkbox"}
                        className={"form-check-input"}
                      />
                      <label
                        htmlFor={"iaai-status"}
                        className={"form-check-label"}
                      >
                        IAAI
                      </label>
                    </div>
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"bid-limit-status"}
                        defaultChecked={[formData].some(
                          (i) => i.hasLimit === true
                        )}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            hasLimit: e.target.checked,
                          }));
                        }}
                        type={"checkbox"}
                        className={"form-check-input"}
                      />
                      <label
                        htmlFor={"bid-limit-status"}
                        className={"form-check-label"}
                      >
                        Set bid limit
                      </label>
                    </div>
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"pre-bid-in-live"}
                        defaultChecked={[formData].some(
                          (i) => i.livePreBid === true
                        )}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            livePreBid: e.target.checked,
                          }));
                        }}
                        type={"checkbox"}
                        className={"form-check-input"}
                      />
                      <label
                        htmlFor={"pre-bid-in-live"}
                        className={"form-check-label"}
                      >
                        Pre bid in live
                      </label>
                    </div>
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"live-bid"}
                        defaultChecked={[formData].some(
                          (i) => i.liveBid === true
                        )}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            liveBid: e.target.checked,
                          }));
                        }}
                        type={"checkbox"}
                        className={"form-check-input"}
                      />
                      <label
                        htmlFor={"live-bid"}
                        className={"form-check-label"}
                      >
                        Live bid
                      </label>
                    </div>
                    <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"lot-history"}
                        defaultChecked={[formData].some(
                          (i) => i.lotHistory === true
                        )}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            lotHistory: e.target.checked,
                          }));
                        }}
                        type={"checkbox"}
                        className={"form-check-input"}
                      />
                      <label
                        htmlFor={"lot-history"}
                        className={"form-check-label"}
                      >
                        Lot history
                      </label>
                    </div>
                  </div>
                </div>
                {formData.lotHistory && (
                  <div className={"form-group"}>
                    <label>Lot history limit</label>
                    <input
                      type={"number"}
                      required
                      value={`${formData.lotHistoryCount}`}
                      className={"form-control"}
                      placeholder={"Enter lot history limit"}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          lotHistoryCount: e.target.value,
                        }));
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className={"col-md-12"} style={{ marginTop: "25px" }}>
              <div
                style={{
                  marginTop: "20px",
                  marginBottom: "15px",
                  borderBottom: "2px solid #dee2e6",
                  paddingBottom: "5px",
                }}
              >
                <h5 style={{ margin: 0, color: "#495057" }}>Calculator</h5>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(1, 1fr)",
                  gap: "10px",
                }}
              >
                       <div
                      className={"form-check"}
                      style={{ marginLeft: "0px", width: "33%" }}
                    >
                      <input
                        id={"enable-calculator"}
                        type={"checkbox"}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            enableCalculator: e.target.checked,
                          }));
                        }}
                        className={"form-check-input"}
                        defaultChecked={[formData].some(
                          (i) => i.enableCalculator === true
                        )}
                      />
                      <label
                        htmlFor={"enable-calculator"}
                        className={"form-check-label"}
                      >
                        Enable calculator
                      </label>
                    </div>
              
              </div>
            </div>
            <div className={"col-md-12"} style={{ marginTop: "25px" }}>
              <div
                style={{
                  marginTop: "20px",
                  marginBottom: "15px",
                  borderBottom: "2px solid #dee2e6",
                  paddingBottom: "5px",
                }}
              >
                <h5 style={{ margin: 0, color: "#495057" }}>Service Fees</h5>
              </div>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "10px",
                }}
              >
                <div className={"form-group"}>
                  <label>Service fee</label>
                  <input
                    type={"number"}
                    required
                    value={`${formData.serviceFee}`}
                    className={"form-control"}
                    placeholder={"Enter service fee"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        serviceFee: e.target.value,
                      }));
                    }}
                  />
                </div>

                <div className={"form-group"}>
                  <label>Insurance by auction fee (%)</label>
                  <input
                    type={"number"}
                    required
                    value={`${formData.insuranceByAuctionFee}`}
                    className={"form-control"}
                    placeholder={"Enter insurance by auction fee %"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        insuranceByAuctionFee: e.target.value,
                      }));
                    }}
                  />
                </div>
                <div className={"form-group"}>
                  <label>Insurance by warehouse fee (%)</label>
                  <input
                    type={"number"}
                    required
                    value={`${formData.insuranceByWarehouseFee}`}
                    className={"form-control"}
                    placeholder={"Enter insurance by warehouse fee %"}
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        insuranceByWarehouseFee: e.target.value,
                      }));
                    }}
                  />
                </div>
              
              </div>
              {(formData.country === "Ukraine" || formData.country === "Poland") && (
                  <div style={{ width: "100%" }}>
                     <div
                style={{
                  marginTop: "20px",
                  marginBottom: "15px",
                  borderBottom: "2px solid #dee2e6",
                  paddingBottom: "5px",
                }}
              >
                <h5 style={{ margin: 0, color: "#495057" }}>Customs Fees</h5>
              </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(2, 1fr)",
                        gap: "10px",
                        marginTop: "10px",
                        fontSize: 14,
                      }}
                    >
                      <div className={"form-group"}>
                        <label style={{fontSize: 16}}>Expedition self pickup fee</label>
                        <input
                          type={"number"}
                          required
                          value={`${formData.expeditionSelfPickupFee}`}
                          className={"form-control"}
                          placeholder={"Enter expedition self pickup fee"}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              expeditionSelfPickupFee: e.target.value,
                            }));
                          }}
                        />
                      </div>
                      <div className={"form-group"}>
                        <label style={{fontSize: 16}}>Expedition complex fee</label>
                        <input
                          type={"number"}
                          required
                          value={`${formData.expeditionComplexFee}`}
                          className={"form-control"}
                          placeholder={"Enter expedition complex fee"}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              expeditionComplexFee: e.target.value,
                            }));
                          }}
                        />
                      </div>
                      <div className={"form-group"}>
                        <label style={{fontSize: 16}}>Expedition basic fee</label>
                        <input
                          type={"number"}
                          required
                          value={`${formData.expeditionBasicFee}`}
                          className={"form-control"}
                          placeholder={"Enter expedition basic fee"}
                          onChange={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              expeditionBasicFee: e.target.value,
                            }));
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
            </div>
         
            <div className={"col-md-12"} style={{ marginTop: "25px" }}>
              <button
                className={"blue-button"}
                style={{ width: "100%" }}
                type={"submit"}
              >
                {action === "edit" ? "Save" : "Create User"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={notification.show}
        onHide={() => setNotification((prev) => ({ ...prev, show: false }))}
      >
        <Modal.Header>
          <h4>{notification.title}</h4>
        </Modal.Header>
        <Modal.Body>{notification.body}</Modal.Body>
        <Modal.Footer>
          <button
            className={"blue-button"}
            onClick={() =>
              setNotification((prev) => ({
                ...prev,
                show: false,
              }))
            }
          >
            {notification.button}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddNewUsers;
